<div *ngIf="!needEmailVerify&&(!needAamsAuth)&&(didAamsAuthCheck)">
    <nav class="navbar navbar-expand-lg navbar-light bg-transparent">

      <a class="navbar-brand" [routerLink]="['/home']" title="Click to go to Home page"><span class="pi pi-home"></span> &nbsp; Assessment Appeals</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav ">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Applications
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/caselookup']">Cases</a>
              <a class="dropdown-item" *ngIf="allowAccess(3)" [routerLink]="['/applicants']">Applicants</a>
              <a class="dropdown-item" *ngIf="allowAccess(3)" [routerLink]="['/agencies']">Agents</a>
              <hr *ngIf="allowAccess(4)" />
              <a class="dropdown-item" *ngIf="allowAccess(4)" [routerLink]="['/efiledapps']" >Import E-filed Applications</a>
              <a class="dropdown-item" *ngIf="allowAccess(4) && allowCaseBackload" [routerLink]="['/backload']" >Backload Cases</a>
            </div>
          </li>
          <li class="nav-item dropdown" *ngIf="allowAccess(4)" >
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Scheduling
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" *ngIf="allowAccess(3)" [routerLink]="['/hearings']" >Set Hearing Dates</a>
              <a class="dropdown-item" [routerLink]="['/schedcases']">Schedule Cases</a>
              <hr />
              <a class="dropdown-item" *ngIf="allowAccess(3)" [routerLink]="['/boardmembers']">Board Members</a>
            </div>
          </li>
          <li class="nav-item dropdown" *ngIf="allowAccess(4)" >
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink4" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="pi pi-print"></span>&nbsp; Notices
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/viewnotices']">View/Print Notices </a>
            </div>
          </li>
          <li class="nav-item dropdown"  >
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Agenda
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/viewagenda']" >View/Print Agenda</a>
              <a class="dropdown-item" *ngIf="allowAccess(3)" [routerLink]="['/updateagenda']" >Update Agenda Cases</a>
              <a class="dropdown-item" [routerLink]="['/agendasummary']" >Agenda Summary</a>
              <a class="dropdown-item" *ngIf="allowAccess(4)" [routerLink]="['/agendaorder']">Agenda Category Order</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink6" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Minutes
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/viewminutes']" >View/Print Minutes </a>
              <a class="dropdown-item" *ngIf="allowAccess(3)" [routerLink]="['/updateminutes']" >Update Minutes </a>
            </div>
          </li>
          <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink7" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Reports
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <a class="dropdown-item" [routerLink]="['/caselist']" >Case List </a>
                <a class="dropdown-item" [routerLink]="['/expirationlist']" >Expiration List </a>
                <a class="dropdown-item" [routerLink]="['/valueatrisk']" >Value at Risk </a>
              </div>
          </li>
          <li class="nav-item dropdown" *ngIf="allowAccess(3)">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink8" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              System
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" *ngIf="allowAccess(3)" [routerLink]="['/user']" >Users </a>
              <a class="dropdown-item" *ngIf="allowAccess(3)" [routerLink]="['/facts']" >Facts </a>
              <a class="dropdown-item" *ngIf="allowAccess(3)" [routerLink]="['/notices']" >Text of Notices </a>
              <a class="dropdown-item" *ngIf="allowAccess(99)" [routerLink]="['/audit']">System Audit Trail</a>
            </div>
          </li>
          <li class="nav-item dropdown" *ngIf="assessorAccess(11)">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink20" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Assessor Dictionaries
              </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" *ngIf="allowAccess(12)" [routerLink]="['/appraiser']">Users</a>
              <a class="dropdown-item" *ngIf="allowAccess(12)" [routerLink]="['/assessor-dict']">Dictionaries</a>
            </div>
          </li>

          <li class="nav-item dropdown" *ngIf="allowAccess(99)" >
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink9" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              EFile Mgr
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/efileview']" >View E-File Applications </a>
              <!-- <a class="dropdown-item" href="" (click)="paymentPortal()">Payment Portal (Heartland)</a> -->
            </div>
          </li>
          <li class="nav-item dropdown" *ngIf="allowAccess(6)" >
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink10" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Dashboard
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/dashboard']" >View Dashboard </a>
              <a class="dropdown-item" *ngIf="allowAccess(99)" [routerLink]="['/casestats']" >Case Statistics - Graph </a>
              <a class="dropdown-item" *ngIf="allowAccess(99)" [routerLink]="['/charts']" >Charts </a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
  <div *ngIf="needEmailVerify">
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-8 offset-1 alert alert-info" >
        Please check your email and verify your registration. Then return here and click Continue.
        &nbsp;
      </div>
      <div class="col-md-1">
        <button class="btn btn-sm btn-success" (click)="continue()" style="margin-top: 10px;">Continue </button>
      </div>
    </div>
  </div>
  <div *ngIf="!needEmailVerify&&(needAamsAuth)&&(didAamsAuthCheck)">
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-8 offset-1 alert alert-info" >
        Please request that your AAMS administrator authorize your e-mail address.
      </div>
    </div>
  </div>
  <div *ngIf="!needEmailVerify&&(needAamsAuth)&&(!didAamsAuthCheck)">
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-8 offset-1 alert alert-success" >
        Working, please wait.
      </div>
    </div>
  </div>
